<template>
  <div>
    <a v-if="hasModulePermission('recruitment') && isAdmin && !hasJobs" :href="jobPostUrl"
       class="text-white d-flex align-items-center justify-content-center"
       style="width: 100%; height: 72px; background-color:#00B0FF; font-size: 15px;margin-bottom: 10px;"><span>Get
        started
        with your
        recruitment. Hire talented employees with a simple step, kindly <b>make a job post</b>.</span>
    </a>
   <div v-if="hasOnboarding">
     <div class="text-white d-flex align-items-center justify-content-center"
       style="background-color: #00b0ff;height: 72px;margin-bottom: 10px;">
       <div style="max-width: 1050px; font-size: 15px;" class="mx-auto">
         Complete Onboarding
         <a :href="userOnboardingUrl" class="font-weight-bold text-white">here</a>.
       </div>
     </div>
   </div>
    <div v-if="leaveLink">
      <div class="text-white d-flex align-items-center justify-content-center"
           style="background-color: #00b0ff;height: 72px;margin-bottom: 10px;">
        <div style="max-width: 1050px; font-size: 15px;" class="mx-auto">
          Approve Pending leaves
          <a @click="goToLeaveLink" href="#" class="font-weight-bold text-white">here</a>.
        </div>
      </div>
    </div>
    <div v-if="hasModulePermission('remote_readiness') && currentUser.remote_readiness_status === false">
      <div class="text-white d-flex align-items-center justify-content-center"
           style="background-color: #00b0ff;height: 72px;margin-bottom: 10px;">
        <div style="max-width: 1050px; font-size: 15px;" class="mx-auto">
          Complete your remote readiness
          <a :href="setUpRemoteReadinessUrl" class="font-weight-bold text-white">here</a>.
        </div>
      </div>
    </div>
    <div v-if="componentReady">
      <div class="container">
        <div class="row mt-0 mt-md-5">
          <!-- If the view is expanded view -->
          <template v-if="expandedTab === 'tasks' && !isMobile">
            <div class="col-12 col-md-4">
              <div class="row">
                <div class="col-12 mb-3">
                  <div class="dashboard-container">
                    <div class="dashboard-container-header">
                      <div class="wfh-h4">Virtual Office</div>
                      <div
                        class="wfh-paragraph-md text-white"
                        style="font-size: 14px"
                      >
                        An overview of the people at your office.
                      </div>
                    </div>
                    <div class="dashboard-container-content">
                      <VirtualOfficeOverview :timezone="timezone" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3">
                  <div class="dashboard-container">
                    <div class="dashboard-container-header">
                      <a
                        @click.prevent="updateExpandedTab('activity_feed')"
                        class="btn-expand"
                        style="right: 25px"
                      >
                        <i class="fas fa-compress"></i>
                      </a>
                      <div class="wfh-h4">Activity Feed</div>
                      <div
                        class="wfh-paragraph-md text-white"
                        style="font-size: 14px"
                      >
                        Latest activity within your company
                      </div>
                    </div>
                    <div class="dashboard-container-content">
                      <activity-feed />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-8" v-if="hasModulePermission('tasks')">
              <div class="row">
                <div class="col-12">
                  <div class="dashboard-container">
                    <div class="dashboard-container-header">
                      <a
                        @click.prevent="updateExpandedTab('tasks')"
                        class="btn-expand"
                        style="right: 25px"
                      >
                        <i class="fas fa-compress"></i>
                      </a>
                      <div class="wfh-h4">Tasks</div>
                      <div
                        class="wfh-paragraph-md text-white"
                        style="font-size: 14px"
                      >
                        Overview of tasks for you and your teammates.
                      </div>
                    </div>
                    <div
                      class="dashboard-container-content"
                      v-if="isExternal"
                    >
                      <external-task-overview></external-task-overview>
                    </div>
                    <div class="dashboard-container-content" v-else>
                      <TaskOverview
                        :current-user="currentUser"
                        :timezone="timezone"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="expandedTab === 'activity_feed' && !isMobile">
            <div class="col-12 col-md-4">
              <div class="row">
                <div class="col-12 mb-3">
                  <div class="dashboard-container">
                    <div class="dashboard-container-header">
                      <div class="wfh-h4">Virtual Office</div>
                      <div
                        class="wfh-paragraph-md text-white"
                        style="font-size: 14px"
                      >
                        An overview of the people at your office.
                      </div>
                    </div>
                    <div class="dashboard-container-content">
                      <VirtualOfficeOverview :timezone="timezone" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3" v-if="hasModulePermission('tasks')">
                  <div class="dashboard-container">
                    <div class="dashboard-container-header">
                      <a
                        @click.prevent="updateExpandedTab('tasks')"
                        class="btn-expand"
                        style="right: 25px"
                      >
                        <i class="fas fa-compress"></i>
                      </a>
                      <div class="wfh-h4">Tasks</div>
                      <div
                        class="wfh-paragraph-md text-white"
                        style="font-size: 14px"
                      >
                        Overview of tasks for you and your teammates.
                      </div>
                    </div>
                    <div
                      class="dashboard-container-content"
                      v-if="isExternal"
                    >
                      <external-task-overview></external-task-overview>
                    </div>
                    <div class="dashboard-container-content" v-else>
                      <TaskOverview
                        :current-user="currentUser"
                        :timezone="timezone"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-8">
              <div class="row">
                <div class="col-12">
                  <div class="dashboard-container">
                    <div class="dashboard-container-header">
                      <a
                        @click.prevent="updateExpandedTab('activity_feed')"
                        class="btn-expand"
                        style="right: 25px"
                      >
                        <i class="fas fa-compress"></i>
                      </a>
                      <div class="wfh-h4">Activity Feed</div>
                      <div
                        class="wfh-paragraph-md text-white"
                        style="font-size: 14px"
                      >
                        Latest activity within your company
                      </div>
                    </div>
                    <div class="dashboard-container-content">
                      <activity-feed />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="col-12 col-md-4 px-0 px-md-2"
              v-if="(currentPage === 'office' && isMobile) || !isMobile"
            >
              <div class="dashboard-container">
                <div class="dashboard-container-header">
                  <div class="wfh-h4">Virtual Office</div>
                  <div
                    class="wfh-paragraph-md text-white"
                    style="font-size: 14px"
                  >
                    An overview of the people at your office.
                  </div>
                </div>
                <div class="dashboard-container-content">
                  <VirtualOfficeOverview :timezone="timezone" />
                </div>
              </div>
            </div>
            <div
              class="col-12 px-0 px-md-2 col-md-4"
              v-if="
                ((currentPage === 'tasks' && isMobile) || !isMobile) &&
                hasModulePermission('tasks')
              "
            >
              <div class="dashboard-container">
                <div class="dashboard-container-header">
                  <a
                    v-if="!isMobile"
                    @click.prevent="updateExpandedTab('tasks')"
                    class="btn-expand"
                  >
                    <i class="fas fa-expand"></i>
                  </a>
                  <div class="wfh-h4">Tasks</div>
                  <div
                    class="wfh-paragraph-md text-white"
                    style="font-size: 14px"
                  >
                    Overview of tasks for you and your teammates.
                  </div>
                </div>
                <div
                  class="dashboard-container-content"
                  v-if="isExternal"
                >
                  <external-task-overview></external-task-overview>
                </div>
                <div class="dashboard-container-content" v-else>
                  <TaskOverview
                    :current-user="currentUser"
                    :timezone="timezone"
                  />
                </div>
              </div>
            </div>
            <div
              :class="{
                'col-12 px-0 px-md-2': true,
                'col-md-4': expandedTab !== 'activity_feed',
                'col-md-8': expandedTab === 'activity_feed',
              }"
              v-if="(currentPage === 'activity-feed' && isMobile) || !isMobile"
            >
              <div class="dashboard-container">
                <div class="dashboard-container-header">
                  <a
                    v-if="!isMobile"
                    @click.prevent="updateExpandedTab('activity_feed')"
                    class="btn-expand"
                  >
                    <i class="fas fa-expand"></i>
                  </a>
                  <div class="wfh-h4">Activity Feed</div>
                  <div
                    class="wfh-paragraph-md text-white"
                    style="font-size: 14px"
                  >
                    Latest activity within your company
                  </div>
                </div>
                <div class="dashboard-container-content">
                  <activity-feed />
                </div>
              </div>
            </div>
          </template>
        </div>

        <div style="height: 240px"></div>
      </div>
    </div>

    <actions-fab
      :isDashboard="true"
      :photoCheckin="isPhotoCheckin"
    ></actions-fab>
    <dashboard-bottom-navbar
      :currentPage="currentPage"
      v-on:pageChanged="changePage"
    ></dashboard-bottom-navbar>
  </div>
</template>

<script>
import VirtualOfficeOverview from "./VirtualOfficeOverview.vue"
import TaskOverview from "../Task/TaskOverview.vue"
import { setExpandedTab, getExpandedTab } from "../../repositories/dashboardStatePersistance"
import datalist from "caniuse-lite/data/features/datalist"


const RECRUITMENT_ACCESS = "recruitment"

export default {
  components: { VirtualOfficeOverview, TaskOverview, setExpandedTab },

  props: ['leaveLink','hasJobs'],

  data() {
    return {
      currentPage: "tasks",
      isMobile: false,
      xDown: null,
      yDown: null,
      task: {},
      taskType: "todo",
      expandTask: false,
      completedOnboarding: true,
      isAdmin: false,
      defaultedTab: null,
    }
  },

  computed: {
    currentUser() {
      return this.$store.state.currentUser
    },

    timezone() {
      return this.$store.state.timezone
    },

    isExternal() {
      return this.$store.state.isExternal
    },

    expandedTab() {
      if (!hasPermission('tasks')) {
        return 'activity_feed'
      }

      return getExpandedTab()
    },

    componentReady() {
      return (
        Object.keys(JSON.parse(JSON.stringify(this.currentUser))).length > 0
      )
    },

    jobPostUrl() {
      return route('redirect.employer.create.job');
    },
    setupOnboardingUrl() {
      return `/onboarding/user-details`;
    },
    setUpRemoteReadinessUrl() {
      return `/setup/remote-readiness`
    },

    isPhotoCheckin() {
      if (this.currentUser.company) {
        return this.currentUser.company.photo_checkin
      }

      return false
    },

    getLeaveUrl() {
      return this.leaveLink
    },

    hasOnboarding(){
      return this.currentUser.has_onboarding ?? false;
    },

    userOnboardingUrl(){
      return this.currentUser.user_onboarding_url;
    }
  },
  updated() {
    this.defaultTab()
  },

  watch: {
    currentUser() {
      this.completedOnboarding = this.currentUser.completed_steps.includes(2)
      this.isAdmin = this.currentUser.type === 'admin'
    },
  },

  methods: {
    hasModulePermission(permission) {
      return hasPermission(permission)
    },


    getTouches(evt) {
      return evt.touches || evt.originalEvent.touches
    },

    handleTouchStart(evt) {
      const firstTouch = this.getTouches(evt)[0]
      this.xDown = firstTouch.clientX
      this.yDown = firstTouch.clientY
    },

    handleTouchMove(evt) {
      if (!this.xDown || !this.yDown) {
        return
      }

      var xUp = evt.touches[0].clientX
      var yUp = evt.touches[0].clientY

      var xDiff = this.xDown - xUp
      var yDiff = this.yDown - yUp

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (xDiff > 0) {
          if (this.currentPage === "tasks") {
            this.currentPage = "activity-feed"
          } else if (this.currentPage === "office") {
            this.currentPage = "tasks"
          } else if (this.currentPage === "office") {
            this.currentPage = "tasks"
          }
        } else {
          if (this.currentPage === "tasks") {
            this.currentPage = "office"
          } else if (this.currentPage === "tasks") {
            this.currentPage = "office"
          } else if (this.currentPage === "activity-feed") {
            this.currentPage = "tasks"
          }
        }
      }

      this.xDown = null
      this.yDown = null
    },

    handleWindowSizeChange() {
      this.isMobile = screen.width < 816
    },

    changePage(page) {
      this.currentPage = page
    },

    updateExpandedTab(tab) {
      if (tab === this.expandedTab) {
        tab = null
      }

      setExpandedTab(tab)
    },

    defaultTab() {
      let tab = ''
      if (this.$store.state.isExternal && hasPermission('tasks')) {
        tab = 'tasks'
      } else {
        tab = 'activity_feed'
      }
      if (this.defaultedTab === null && getExpandedTab() === null) {
        this.defaultedTab = tab
        this.updateExpandedTab(tab)
      }
    },
    goToLeaveLink() {
      if (this.listingLink) {
        this.tab = 'pending'
      }

      window.location.href = `${this.leaveLink}?tab=pending`
    },


  },

  mounted() {
    this.isMobile = screen.width < 816

    window.addEventListener("resize", this.handleWindowSizeChange, false)

    //TODO: Refactor touch detection
    document.addEventListener("touchstart", this.handleTouchStart, false)
    document.addEventListener("touchmove", this.handleTouchMove, false)

    // this.getCurrentUser();
  },

};
</script>

<style lang="scss" scoped>
@import "../../../sass/core/mixins";

.dashboard-container {
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);

  @include media-breakpoint-up(sm) {
    border-radius: 0 0 8px 8px;
  }
}

.dashboard-container-header {
  height: 128px;
  padding: 36px 21px 24px;
  background: linear-gradient(133.27deg, #0b1324 0%, #0f3266 100%);

  @include media-breakpoint-up(sm) {
    border-radius: 8px 8px 0 0;
  }

  .btn-expand {
    color: #fff;
    padding: 10px;
    position: absolute;
    top: 5px;
    right: 15px;
    cursor: pointer;
  }
}

.dashboard-container-content {
  padding: 24px 21px 11px;

  @include media-breakpoint-up(sm) {
    border-radius: 0 0 8px 8px;
  }
}
</style>
